import { render } from "./ShareLinkCard.vue?vue&type=template&id=736093cc"
import script from "./ShareLinkCard.vue?vue&type=script&lang=js"
export * from "./ShareLinkCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__